import { render, staticRenderFns } from "./PotentialResourcesCollectInfoAdd.vue?vue&type=template&id=52df7ba2&"
import script from "./PotentialResourcesCollectInfoAdd.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesCollectInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesCollectInfoAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports